module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_7042.ab8ccd6b.png";